/**
 * The progress rules live in shared-ui, so the patient portal and the
 * therapist app judge a week, a streak and a badge the same way. This module
 * keeps the portal's import paths; the rules themselves are documented in
 * sophy-shared-ui/src/utils/gamification.js.
 */
import { gamification } from "@sophy/shared-ui";

export const {
  startOfDay,
  startOfWeek,
  addDays,
  sessionDates,
  plannedSessions,
  isProgramActive,
  isQuestionnaireSession,
  isFeedbackSession,
  programWeek,
  programStreak,
  longestStreak,
  weekOverview,
  MILESTONE_IDS,
  programMilestones,
  wellbeing,
  BADGE_IDS,
  REPORTER_TARGET,
  STAYING_POWER_WEEKS,
  EARLY_BIRD_HOUR,
  badges,
  newBadges,
  withSession,
  sessionOutcome,
} = gamification;
